export default __webpack_public_path__ + "static/media/whatBanner.93b86812.webp";